// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WifiQrCodeGeneratorRouteImport } from './routes/wifi-qr-code-generator'
import { Route as VcardQrGeneratorRouteImport } from './routes/vcard-qr-generator'
import { Route as UpcLookupRouteImport } from './routes/upc-lookup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as Sunrise2027RouteImport } from './routes/sunrise-2027'
import { Route as ReadersRouteImport } from './routes/readers'
import { Route as ReadBarcodeFromImageRouteImport } from './routes/read-barcode-from-image'
import { Route as ReadBarcodeAppRouteImport } from './routes/read-barcode-app'
import { Route as QrCodeReaderRouteImport } from './routes/qr-code-reader'
import { Route as QrCodeGeneratorRouteImport } from './routes/qr-code-generator'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as Pdf417GeneratorRouteImport } from './routes/pdf417-generator'
import { Route as LookupValidatorsRouteImport } from './routes/lookup-validators'
import { Route as Itf14LabelGeneratorRouteImport } from './routes/itf-14-label-generator'
import { Route as IsbnBarcodeReaderRouteImport } from './routes/isbn-barcode-reader'
import { Route as InventoryScannerRouteImport } from './routes/inventory-scanner'
import { Route as GtinValidatorRouteImport } from './routes/gtin-validator'
import { Route as Gs1InventoryRouteImport } from './routes/gs1-inventory'
import { Route as Gs1DigitalLinkGeneratorRouteImport } from './routes/gs1-digital-link-generator'
import { Route as Gs1DigitalLinkDecoderRouteImport } from './routes/gs1-digital-link-decoder'
import { Route as GeneratorsRouteImport } from './routes/generators'
import { Route as EanLookupRouteImport } from './routes/ean-lookup'
import { Route as DataMatrixReaderRouteImport } from './routes/data-matrix-reader'
import { Route as DataMatrixGeneratorRouteImport } from './routes/data-matrix-generator'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CheckDigitCalculatorRouteImport } from './routes/check-digit-calculator'
import { Route as BulkBarcodeGeneratorRouteImport } from './routes/bulk-barcode-generator'
import { Route as BatchBarcodeScannerRouteImport } from './routes/batch-barcode-scanner'
import { Route as BarcodeTypeDetectorRouteImport } from './routes/barcode-type-detector'
import { Route as BarcodeReaderRouteImport } from './routes/barcode-reader'
import { Route as BarcodeGuidesRouteImport } from './routes/barcode-guides'
import { Route as BarcodeGeneratorRouteImport } from './routes/barcode-generator'
import { Route as AztecCodeGeneratorRouteImport } from './routes/aztec-code-generator'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BarcodeGuidesIndexRouteImport } from './routes/barcode-guides.index'
import { Route as BarcodeGuidesWhatIsAGtinRouteImport } from './routes/barcode-guides.what-is-a-gtin'
import { Route as BarcodeGuidesUpcVsEanRouteImport } from './routes/barcode-guides.upc-vs-ean'
import { Route as BarcodeGuidesSunrise2027ExplainedRouteImport } from './routes/barcode-guides.sunrise-2027-explained'
import { Route as BarcodeGuidesGs1DigitalLinkRouteImport } from './routes/barcode-guides.gs1-digital-link'
import { Route as BarcodeGuidesCode128ExplainedRouteImport } from './routes/barcode-guides.code-128-explained'
import { Route as BarcodeGuidesCheckDigitsExplainedRouteImport } from './routes/barcode-guides.check-digits-explained'
import { Route as BarcodeGuidesBarcodeFormatsRouteImport } from './routes/barcode-guides.barcode-formats'
import { Route as BarcodeGuides1dVs2dBarcodesRouteImport } from './routes/barcode-guides.1d-vs-2d-barcodes'

const WifiQrCodeGeneratorRoute = WifiQrCodeGeneratorRouteImport.update({
            id: '/wifi-qr-code-generator',path: '/wifi-qr-code-generator',getParentRoute: () => rootRouteImport
          })
const VcardQrGeneratorRoute = VcardQrGeneratorRouteImport.update({
            id: '/vcard-qr-generator',path: '/vcard-qr-generator',getParentRoute: () => rootRouteImport
          })
const UpcLookupRoute = UpcLookupRouteImport.update({
            id: '/upc-lookup',path: '/upc-lookup',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const Sunrise2027Route = Sunrise2027RouteImport.update({
            id: '/sunrise-2027',path: '/sunrise-2027',getParentRoute: () => rootRouteImport
          })
const ReadersRoute = ReadersRouteImport.update({
            id: '/readers',path: '/readers',getParentRoute: () => rootRouteImport
          })
const ReadBarcodeFromImageRoute = ReadBarcodeFromImageRouteImport.update({
            id: '/read-barcode-from-image',path: '/read-barcode-from-image',getParentRoute: () => rootRouteImport
          })
const ReadBarcodeAppRoute = ReadBarcodeAppRouteImport.update({
            id: '/read-barcode-app',path: '/read-barcode-app',getParentRoute: () => rootRouteImport
          })
const QrCodeReaderRoute = QrCodeReaderRouteImport.update({
            id: '/qr-code-reader',path: '/qr-code-reader',getParentRoute: () => rootRouteImport
          })
const QrCodeGeneratorRoute = QrCodeGeneratorRouteImport.update({
            id: '/qr-code-generator',path: '/qr-code-generator',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const Pdf417GeneratorRoute = Pdf417GeneratorRouteImport.update({
            id: '/pdf417-generator',path: '/pdf417-generator',getParentRoute: () => rootRouteImport
          })
const LookupValidatorsRoute = LookupValidatorsRouteImport.update({
            id: '/lookup-validators',path: '/lookup-validators',getParentRoute: () => rootRouteImport
          })
const Itf14LabelGeneratorRoute = Itf14LabelGeneratorRouteImport.update({
            id: '/itf-14-label-generator',path: '/itf-14-label-generator',getParentRoute: () => rootRouteImport
          })
const IsbnBarcodeReaderRoute = IsbnBarcodeReaderRouteImport.update({
            id: '/isbn-barcode-reader',path: '/isbn-barcode-reader',getParentRoute: () => rootRouteImport
          })
const InventoryScannerRoute = InventoryScannerRouteImport.update({
            id: '/inventory-scanner',path: '/inventory-scanner',getParentRoute: () => rootRouteImport
          })
const GtinValidatorRoute = GtinValidatorRouteImport.update({
            id: '/gtin-validator',path: '/gtin-validator',getParentRoute: () => rootRouteImport
          })
const Gs1InventoryRoute = Gs1InventoryRouteImport.update({
            id: '/gs1-inventory',path: '/gs1-inventory',getParentRoute: () => rootRouteImport
          })
const Gs1DigitalLinkGeneratorRoute = Gs1DigitalLinkGeneratorRouteImport.update({
            id: '/gs1-digital-link-generator',path: '/gs1-digital-link-generator',getParentRoute: () => rootRouteImport
          })
const Gs1DigitalLinkDecoderRoute = Gs1DigitalLinkDecoderRouteImport.update({
            id: '/gs1-digital-link-decoder',path: '/gs1-digital-link-decoder',getParentRoute: () => rootRouteImport
          })
const GeneratorsRoute = GeneratorsRouteImport.update({
            id: '/generators',path: '/generators',getParentRoute: () => rootRouteImport
          })
const EanLookupRoute = EanLookupRouteImport.update({
            id: '/ean-lookup',path: '/ean-lookup',getParentRoute: () => rootRouteImport
          })
const DataMatrixReaderRoute = DataMatrixReaderRouteImport.update({
            id: '/data-matrix-reader',path: '/data-matrix-reader',getParentRoute: () => rootRouteImport
          })
const DataMatrixGeneratorRoute = DataMatrixGeneratorRouteImport.update({
            id: '/data-matrix-generator',path: '/data-matrix-generator',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CheckDigitCalculatorRoute = CheckDigitCalculatorRouteImport.update({
            id: '/check-digit-calculator',path: '/check-digit-calculator',getParentRoute: () => rootRouteImport
          })
const BulkBarcodeGeneratorRoute = BulkBarcodeGeneratorRouteImport.update({
            id: '/bulk-barcode-generator',path: '/bulk-barcode-generator',getParentRoute: () => rootRouteImport
          })
const BatchBarcodeScannerRoute = BatchBarcodeScannerRouteImport.update({
            id: '/batch-barcode-scanner',path: '/batch-barcode-scanner',getParentRoute: () => rootRouteImport
          })
const BarcodeTypeDetectorRoute = BarcodeTypeDetectorRouteImport.update({
            id: '/barcode-type-detector',path: '/barcode-type-detector',getParentRoute: () => rootRouteImport
          })
const BarcodeReaderRoute = BarcodeReaderRouteImport.update({
            id: '/barcode-reader',path: '/barcode-reader',getParentRoute: () => rootRouteImport
          })
const BarcodeGuidesRoute = BarcodeGuidesRouteImport.update({
            id: '/barcode-guides',path: '/barcode-guides',getParentRoute: () => rootRouteImport
          })
const BarcodeGeneratorRoute = BarcodeGeneratorRouteImport.update({
            id: '/barcode-generator',path: '/barcode-generator',getParentRoute: () => rootRouteImport
          })
const AztecCodeGeneratorRoute = AztecCodeGeneratorRouteImport.update({
            id: '/aztec-code-generator',path: '/aztec-code-generator',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BarcodeGuidesIndexRoute = BarcodeGuidesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BarcodeGuidesRoute
          })
const BarcodeGuidesWhatIsAGtinRoute = BarcodeGuidesWhatIsAGtinRouteImport.update({
            id: '/what-is-a-gtin',path: '/what-is-a-gtin',getParentRoute: () => BarcodeGuidesRoute
          })
const BarcodeGuidesUpcVsEanRoute = BarcodeGuidesUpcVsEanRouteImport.update({
            id: '/upc-vs-ean',path: '/upc-vs-ean',getParentRoute: () => BarcodeGuidesRoute
          })
const BarcodeGuidesSunrise2027ExplainedRoute = BarcodeGuidesSunrise2027ExplainedRouteImport.update({
            id: '/sunrise-2027-explained',path: '/sunrise-2027-explained',getParentRoute: () => BarcodeGuidesRoute
          })
const BarcodeGuidesGs1DigitalLinkRoute = BarcodeGuidesGs1DigitalLinkRouteImport.update({
            id: '/gs1-digital-link',path: '/gs1-digital-link',getParentRoute: () => BarcodeGuidesRoute
          })
const BarcodeGuidesCode128ExplainedRoute = BarcodeGuidesCode128ExplainedRouteImport.update({
            id: '/code-128-explained',path: '/code-128-explained',getParentRoute: () => BarcodeGuidesRoute
          })
const BarcodeGuidesCheckDigitsExplainedRoute = BarcodeGuidesCheckDigitsExplainedRouteImport.update({
            id: '/check-digits-explained',path: '/check-digits-explained',getParentRoute: () => BarcodeGuidesRoute
          })
const BarcodeGuidesBarcodeFormatsRoute = BarcodeGuidesBarcodeFormatsRouteImport.update({
            id: '/barcode-formats',path: '/barcode-formats',getParentRoute: () => BarcodeGuidesRoute
          })
const BarcodeGuides1dVs2dBarcodesRoute = BarcodeGuides1dVs2dBarcodesRouteImport.update({
            id: '/1d-vs-2d-barcodes',path: '/1d-vs-2d-barcodes',getParentRoute: () => BarcodeGuidesRoute
          })





const BarcodeGuidesRouteChildren = {
  BarcodeGuides1dVs2dBarcodesRoute: BarcodeGuides1dVs2dBarcodesRoute,BarcodeGuidesBarcodeFormatsRoute: BarcodeGuidesBarcodeFormatsRoute,BarcodeGuidesCheckDigitsExplainedRoute: BarcodeGuidesCheckDigitsExplainedRoute,BarcodeGuidesCode128ExplainedRoute: BarcodeGuidesCode128ExplainedRoute,BarcodeGuidesGs1DigitalLinkRoute: BarcodeGuidesGs1DigitalLinkRoute,BarcodeGuidesSunrise2027ExplainedRoute: BarcodeGuidesSunrise2027ExplainedRoute,BarcodeGuidesUpcVsEanRoute: BarcodeGuidesUpcVsEanRoute,BarcodeGuidesWhatIsAGtinRoute: BarcodeGuidesWhatIsAGtinRoute,BarcodeGuidesIndexRoute: BarcodeGuidesIndexRoute
}

const BarcodeGuidesRouteWithChildren = BarcodeGuidesRoute._addFileChildren(BarcodeGuidesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AztecCodeGeneratorRoute: AztecCodeGeneratorRoute,BarcodeGeneratorRoute: BarcodeGeneratorRoute,BarcodeGuidesRoute: BarcodeGuidesRouteWithChildren,BarcodeReaderRoute: BarcodeReaderRoute,BarcodeTypeDetectorRoute: BarcodeTypeDetectorRoute,BatchBarcodeScannerRoute: BatchBarcodeScannerRoute,BulkBarcodeGeneratorRoute: BulkBarcodeGeneratorRoute,CheckDigitCalculatorRoute: CheckDigitCalculatorRoute,ContactRoute: ContactRoute,DataMatrixGeneratorRoute: DataMatrixGeneratorRoute,DataMatrixReaderRoute: DataMatrixReaderRoute,EanLookupRoute: EanLookupRoute,GeneratorsRoute: GeneratorsRoute,Gs1DigitalLinkDecoderRoute: Gs1DigitalLinkDecoderRoute,Gs1DigitalLinkGeneratorRoute: Gs1DigitalLinkGeneratorRoute,Gs1InventoryRoute: Gs1InventoryRoute,GtinValidatorRoute: GtinValidatorRoute,InventoryScannerRoute: InventoryScannerRoute,IsbnBarcodeReaderRoute: IsbnBarcodeReaderRoute,Itf14LabelGeneratorRoute: Itf14LabelGeneratorRoute,LookupValidatorsRoute: LookupValidatorsRoute,Pdf417GeneratorRoute: Pdf417GeneratorRoute,PrivacyRoute: PrivacyRoute,QrCodeGeneratorRoute: QrCodeGeneratorRoute,QrCodeReaderRoute: QrCodeReaderRoute,ReadBarcodeAppRoute: ReadBarcodeAppRoute,ReadBarcodeFromImageRoute: ReadBarcodeFromImageRoute,ReadersRoute: ReadersRoute,Sunrise2027Route: Sunrise2027Route,TermsRoute: TermsRoute,UpcLookupRoute: UpcLookupRoute,VcardQrGeneratorRoute: VcardQrGeneratorRoute,WifiQrCodeGeneratorRoute: WifiQrCodeGeneratorRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)